import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-current",
  "use": "rt-base-current-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-current\"><defs><style type=\"text/css\"></style></defs><path d=\"M355.285333 53.845333c23.893333 0 43.52 17.92 46.250667 41.088l0.298667 5.418667v22.485333l394.965333 205.781334c31.232 16.298667 33.322667 59.349333 5.717333 79.061333l-4.864 3.029333-395.861333 216.832v297.173334a46.506667 46.506667 0 0 1-92.714667 5.418666l-0.341333-5.418666V100.394667c0-25.728 20.864-46.549333 46.549333-46.549334z\" p-id=\"3419\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/current.svg
// module id = 1261
// module chunks = 124